export default __webpack_public_path__ + "static/media/city-video.34f5ba39.mp4";